import { useEffect, useState } from 'react';
import { ReturnsTab } from '../../components/stores/StoresSlice1';
import { apiGet } from '../../lib/api';

export default function MobileMaterialReturn() {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    apiGet('/projects').then(r => setProjects(Array.isArray(r) ? r : (r?.items || r?.projects || []))).catch(() => {});
  }, []);
  return <div className="p-3" data-testid="mobile-material-return-page"><ReturnsTab compact projects={projects} /></div>;
}
